export class Arquivo {
    filename: string;
    filetype: string;
    value: string;
    tipoConteudo: TipoConteudo;
}

export class ArquivoIpd {
  filename: string;
  filetype: string;
  value: string;
  tipoConteudo: TipoConsultaImpedimento;
}

export enum TipoConteudo {
  OPERACOES = '1',
  LIBERACOES = '2',
  SOLICITACOES_HONRA = '3',
  RECUPERACOES_CREDITO = '4',
  AMORTIZACOES_ANTECIPADAS = '5',
  ATUALIZACAO_INFO_RISCO = '6',
  ACOMPANHAMENTO_PROCESSUAL = '7',
  ATUALIZACAO_SCR = '8',
  LEILAO = '10'
}

export enum TipoConsultaImpedimento {
  IMPORTACAO_CERTIDAO_CADIN = '1'
}

export const LabelTipoConteudo = new Map<string, string>([
  [TipoConteudo.OPERACOES, 'operações'],
  [TipoConteudo.LIBERACOES, 'liberações'],
  [TipoConteudo.SOLICITACOES_HONRA, 'solicitações de honra'],
  [TipoConteudo.RECUPERACOES_CREDITO, 'recuperações de crédito'],
  [TipoConteudo.AMORTIZACOES_ANTECIPADAS, 'amortizações antecipadas'],
  [TipoConteudo.ATUALIZACAO_INFO_RISCO, 'atualizações de risco'],
  [TipoConteudo.ACOMPANHAMENTO_PROCESSUAL, 'posição da carteira em recuperação de crédito'],
  [TipoConteudo.ATUALIZACAO_SCR, 'informação de IPOCs'],
  [TipoConteudo.LEILAO, 'leilões']
]);

export const LabelTipoConteudoIpd = new Map<string, string>([

  [TipoConsultaImpedimento.IMPORTACAO_CERTIDAO_CADIN, 'Importacao certidão CADIN']
]);
